<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="style"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';
import { generateClass, getClassDefinition } from '@/utils/tailwind-helper';

export default {
    name: 'calendar-facet-title-font-style',
    mixins: [baseOption],

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            displayName: 'Font Style',
            tailwindDefinitionProp: 'fontStyle',
            style: '',
        };
    },

    computed: {
        options() {
            return this.themeObjectValues.map(v => ({ value: v, text: this.titleCase(v) }));
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(valueNew) {
            let flexClassNew = '';
            if (valueNew) {
                flexClassNew = generateClass({
                    screen: this.screen,
                    tailwindDefinitionProp: this.tailwindDefinitionProp,
                    value: valueNew,
                });
            }

            this.onOptionChange(flexClassNew);
            this.$emit('input', flexClassNew);
        },

        onSelectedElement() {
            if (this.value) {
                const classDefinition = getClassDefinition(this.value);
                if (classDefinition) {
                    this.style = classDefinition.value;
                }
            }
        },
    },
};
</script>
